var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 42,
    viewBox: "0 0 63 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.242 7.41975L57.3131 39.9662C58.0863 41.5215 59.5643 42.362 60.6311 41.85L61.5903 41.3863C62.6473 40.8743 62.8822 39.203 62.1188 37.6573L44.5208 2.03882C44.0119 1.00514 43.18 0.2806 42.3676 0.0680679L42.2599 0.010105H40.6156L40.4982 0.0680679C39.5684 0.0970495 38.5211 0.879555 37.924 2.09679L31.3371 15.438C30.5638 16.9934 30.8085 18.6646 31.8656 19.1767L32.8248 19.6404C33.8818 20.1524 35.3695 19.3022 36.1329 17.7469L41.242 7.41975ZM0.985939 0.60906C-0.0809008 1.12107 -0.315804 2.79235 0.447623 4.3477L18.0456 39.9662C18.6133 41.1158 19.6899 41.879 20.5806 41.9852H20.4631H22.2249L22.3325 41.9079C23.1938 41.7534 24.1041 41.0095 24.6522 39.8986L31.2392 26.567C32.0026 25.0116 31.7677 23.3404 30.7106 22.8283L29.7417 22.3646C28.6846 21.8526 27.2067 22.7028 26.4335 24.2484L21.3342 34.5756L5.2533 2.03882C4.48987 0.483472 3.00217 -0.356997 1.94512 0.145352L0.985939 0.60906Z",
    fill: "url(#paint0_linear_20578_176722)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20578_176722",
    x1: -0.000449256,
    y1: 21,
    x2: 62.5666,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#0E7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8021,
    stopColor: "#42B48B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo_sm.141b64e84f515f02ddcdca972870f4a1.svg";
export { ForwardRef as ReactComponent };